module.exports = __webpack_public_path__ + "static/quote2-8b463f18dc1f594b7aaa2951df239860.jpeg";